import { ReactNode } from 'react';
import { BottomNav } from './BottomNav';

interface AppShellProps {
  children: ReactNode;
}

export function AppShell({ children }: AppShellProps) {
  return (
    <div className="min-h-screen bg-warm-50 dark:bg-gray-950">
      <main className="max-w-lg mx-auto pb-24 min-h-screen">
        {children}
      </main>
      <BottomNav />
    </div>
  );
}
